<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout v-show="chainBlock === true">
        <v-layout>
            <v-flex class="xs12">
                <v-flex class="xs12">
                    <v-select
                            :items="randomTypes"
                            label="Смешивание цепочки сообщений"
                            v-model="messageModel.rnd"
                            value="-1"
                            item-text="text"
                            item-value="value"
                            @change="changeRnd()"
                    ></v-select>
                </v-flex>
                <v-flex class="xs12">
                    <v-combobox
                            :items="messages"
                            v-model="chain"
                            chips
                            label="Цепочка сообщений"
                            multiple
                            clearable
                            persistent-hint
                            item-text="title"
                            item-value="id"
                    >
                        <template v-slot:selection="data">
                            <v-chip
                                    :key="JSON.stringify(data.item).id"
                                    :input-value="data.item.id"
                                    v-bind="data.id"
                                    close
                                    @click.stop="data.parent.selectedIndex = data.index"
                                    @click:close="removeWord(data.index)"
                            >
                                {{ data.item.title }}
                            </v-chip>
                        </template>
                    </v-combobox>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
    name: 'MessageChainBlock',
    data() {
        return {
            randomTypes: [
                { value: -1, text: 'Убрать цепочку сообщений' },
                { value: 0, text: 'Без смешивания' },
                { value: 1, text: 'Случайное одно сообщение из цепочки' },
                { value: 2, text: 'Перемешивание массива в цепочке' },
                { value: 3, text: 'Случайное одно ссобщение из всего массива сообщений' },
                { value: 4, text: 'Перемешивание всех сообщений' }
            ]
        }
    },
    props: ['chainBlock', 'messageModel'],
    methods: {
        changeRnd() {
            if (this.messageModel.rnd === -1) {
                this.messageModel.chain = null
            }
            this.$emit('saveMessage')
        },
        removeWord() {
            let chain = this.messageModel.chain.split(',').map(Number)
            this.messageModel.chain = chain.join(',')
        }
    },
    computed: {
        ...mapGetters({
            messages: 'messages/messages'
        }),
        chain: {
            get() {
                if (this.messageModel.chain != null) {
                    let chain = this.messageModel.chain.split(',').map(Number)
                    if (chain.length > 0) {
                        let chainNew = []
                        for (let j = 0; j < this.messages.length; j++) {
                            for (let i = 0; i < chain.length; i++) {
                                if (this.messages[j].id === chain[i]) { chainNew.push(this.messages[j]) }
                            }
                        }
                        return chainNew
                    }
                }
                return []
            },
            set(value) {
                let chain = []
                for (let i = 0; i < value.length; i++) {
                    chain.push(value[i].id)
                }
                this.messageModel.chain = chain.join(',')
                this.$emit('saveMessage')
            }
        }
    }
}
</script>

<style scoped>

</style>
